import {
  IReturn,
  getAnalyticDataFromBreadcrumb,
} from "@src/analytics/getAnalyticData";
import { IUpdate } from "./filterState";
import {
  searchFilterInteractionOptionsEvent,
  searchFilterInteractionRentEvent,
  searchFilterInteractionRoomsizeEvent,
  searchFilterInteractionRoomtypeEvent,
} from "@src/analytics";

enum ERoomOption {
  "エレベーター",
  "駐車場・駐輪場",
  "ペット",
  "空室",
}

enum ERoomSize {
  "30 m² 以下",
  "30 m² ~ 40 m²",
  "40 m² ~ 50 m²",
  "50 m² 以上",
}

enum ERoomRent {
  "¥30,000 以下",
  "¥30,000 ~ ¥40,000",
  "¥40,000 ~ ¥50,000",
  "¥50,000 以上",
}

function pushEvent(regionalInfo: IReturn, item: IUpdate) {
  const RegionalInformation = {
    selected_province: regionalInfo.prefectures?.name ?? null,
    selected_district: regionalInfo.districts ?? null,
    selected_city: regionalInfo.cities?.name ?? null,
    selected_railway_line: regionalInfo.lines?.name ?? null,
    selected_station: regionalInfo.stations?.name ?? null,
  };
  switch (item.type) {
    case "room-option": {
      searchFilterInteractionOptionsEvent({
        selected_option: ERoomOption[Number(item.value)] ?? item.value,
        ...RegionalInformation,
      });
      break;
    }
    case "room-type": {
      searchFilterInteractionRoomtypeEvent({
        selected_roomtype: item.value,
        ...RegionalInformation,
      });

      break;
    }
    case "room-size": {
      searchFilterInteractionRoomsizeEvent({
        selected_roomsize: ERoomSize[Number(item.value)] ?? item.value,
        ...RegionalInformation,
      });

      break;
    }
    case "room-rent": {
      searchFilterInteractionRentEvent({
        selected_rent: ERoomRent[Number(item.value)] ?? item.value,
        ...RegionalInformation,
      });
      break;
    }
  }
}

export function anaFilterOption(item: IUpdate) {
  if (!item.checked) return;

  getAnalyticDataFromBreadcrumb(true).then((res) => {
    if ("forEach" in res) {
      res.forEach((info) => {
        pushEvent(info, item);
      });
    } else {
      pushEvent(res, item);
    }
  });
}
